import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-fe',
  templateUrl: './fe.component.html',
  styleUrls: ['./fe.component.scss'],
  standalone: false,
})
export class FEComponent implements OnInit {
  isHomeRoute: boolean = false;

  constructor(private router: Router) {}

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  ngOnInit(): void {
    this.checkIfHome(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkIfHome(event.urlAfterRedirects);
      });
  }

  private checkIfHome(url: string) {
    this.isHomeRoute = url === '/fe';
  }
}
